import { empresaServicios } from '@/content/site'
import { Icon } from '@/components/Icon'
import styles from './Empresas.module.css'

export function Empresas() {
  return (
    <section id="empresas" className="section">
      <div className={`container ${styles.inner}`}>
        <div className={`${styles.copy} reveal`}>
          <p className="eyebrow">Empresas</p>
          <h2 className="section-title">Personas que crecen construyen organizaciones que crecen.</h2>
          <p className="section-lead">
            Programas, talleres y experiencias orientados a fortalecer habilidades, liderazgo,
            comunicación, motivación y desarrollo dentro de las organizaciones.
          </p>
          <p className={styles.call}>Cuéntame qué está viviendo tu equipo.</p>
          <a href="#contacto" className="btn btn--primary btn--lg">
            Conversemos
          </a>
        </div>

        <ul className={`${styles.list} reveal`}>
          {empresaServicios.map((s) => (
            <li key={s} className={styles.item}>
              <span className={styles.check}>
                <Icon name="check" size={16} />
              </span>
              {s}
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
